import getters from '@/store/modules/settings/getters'
import mutations from '@/store/modules/settings/mutations'
import actions from '@/store/modules/settings/actions'

export default {
  namespaced: true,
  state() {
    return {
      settings: {},
      systemSettings: {},
      settingsMetadata: {},
      settingsEvent_kinds: {},
      packageVersion: import.meta.env.VITE_APP_VERSION || 'not found'
    }
  },
  getters,
  actions,
  mutations
}
